import { combineReducers } from 'redux';
import abstracts from './fetchers/abstracts';
import activePageIndex from './activePageIndex';
import authorContext from './fetchers/authorContext';
import authors from './fetchers/authors';
import buttonListWidth from './buttonListWidth';
import citingArticles from './fetchers/citingArticles';
import clientSize from './clientSize';
import connections from './fetchers/connections';
import defaultPageSize from './defaultPageSize';
import extras from './fetchers/extras';
import figures from './fetchers/figures';
import find from './find';
import isLoadingDocumentForPrint from './printState';
import listContainerWidth from './listContainerWidth';
import loadingState from './loadingState';
import outline from './outline';
import pdfDocument from './pdfDocument';
import recommendations from './fetchers/recommendations';
import references from './fetchers/references';
import referencesContext from './fetchers/referencesContext';
import rotations from './rotations';
import scale from './scale';
import siblings from './fetchers/siblings';
import sidebar from './sidebar';
import stayFitToWidth from './stayFitToWidth';
import token from './token';
import pdfContent from './pdfContent';

function noopObj(state = {}) {
  return state;
}

function noopStr(state = '') {
  return state;
}

export default combineReducers({
  abstracts,
  activePageIndex,
  adobeTargetValue: noopObj,
  authorContext,
  authors,
  buttonListWidth,
  citingArticles,
  clientSize,
  connections,
  defaultPageSize,
  extras,
  figures,
  find,
  idType: noopStr,
  isLoadingDocumentForPrint,
  listContainerWidth,
  loadingState,
  metadata: noopObj,
  outline,
  pdfContent,
  pdfDocument,
  recommendations,
  references,
  referencesContext,
  rotations,
  scale,
  siblings,
  sidebar,
  stayFitToWidth,
  token,
  viewConfig: noopObj,
});
